<div class="members-container">
    <div class="members-header">
        <div class="header-left">
            <img src="assets/images/icons/users-small.png" alt="users Icon" class="file-icon">
            <span class="header-title">
            <span class="title-text">Clients ( <span class="title-count">{{ totalCount }}</span> )</span>

            </span>
        </div>

        <div class="header-right">
            <button *ngIf="members.length > 0" class="add-article-btn" (click)="exportMembers()" [disabled]="isLoading">
                <img src="assets/images/icons/user-btn.png" alt="user" class="add-icon">
                <span *ngIf="!isLoading">Export</span>
                <span *ngIf="isLoading">Export en cours...</span>
            </button>
            <button class="add-article-btn" (click)="addClient()">
                <img src="assets/images/icons/user_plus.png" alt="user" class="add-icon">
                <span>Ajouter un client</span>
            </button>
        </div>
    </div>

    <div class="search-filter-row">
        <div class="search-container">
            <div class="search-input-group">
                <img src="assets/images/icons/input_search.png" alt="Search" class="search-icon">
                <input type="text" class="search-input" placeholder="Rechercher des membres..." [(ngModel)]="searchTerm" (input)="onSearch()">
            </div>
        </div>
        <div class="filter-group">
            <select class="filter-select custom-select" [(ngModel)]="selectedVisibility" (change)="onFilterChange()">
                <option value="all">Tous(Visibilité)</option>
                <option value="true">Compte Activer</option>
                <option value="false">Compte Inactive</option>
            </select>
        </div>

        <div class="filter-group">
            <select class="filter-select custom-select" [(ngModel)]="selectedSort" (change)="onSortChange()">
                <option value="" disabled>Trier par</option>
                <option value="createdAt,desc">Date (plus récent)</option>
                <option value="createdAt,asc">Date (plus ancien)</option>
                <option value="firstName,asc">Nom (A-Z)</option>
                <option value="firstName,desc">Nom (Z-A)</option>
            </select>
        </div>

        <button class="filter-btn" (click)="toggleFilterPopup()">
            <img src="assets/images/icons/filter.png" alt="Filter" class="filter-icon">
            <span>Filtrer</span>
        </button>
    </div>

    <div *ngIf="isLoading" class="loading-state">
        <div class="loading-spinner"></div>
        <p>Chargement des clients...</p>
    </div>

    <div *ngIf="!isLoading && members.length === 0" class="empty-state">
        <p>Aucun client trouvé</p>
        <button class="add-first-btn" (click)="addClient()">
            Ajouter un client
        </button>
    </div>

    <div *ngIf="!isLoading && members.length > 0" class="members-grid">
        <app-admin-member-card *ngFor="let member of members" [member]="member" (memberUpdated)="onMemberUpdated()" (memberDeleted)="onMemberDeleted()">
        </app-admin-member-card>
        @if(totalPages>1){
        <app-pagination [currentPage]="currentPage" [totalPages]="totalPages" (pageChange)="onPageChange($event)"></app-pagination>
        }
    </div>
</div>